import { useState } from "react";
import { toast } from "sonner";
import { api, formatError, useApi } from "@/lib/api";
import { useAuth } from "./AuthContext";
import { AdminTitle, AInput, ASelect, Table } from "./AdminUi";

const EMPTY = { slug: "", hub: "direction", name: "", description: "" };

export default function AdminCategories() {
  const { user } = useAuth();
  const { data, reload } = useApi("/categories");
  const [f, setF] = useState(EMPTY);
  const [editId, setEditId] = useState(null);
  const set = (k) => (v) => setF((s) => ({ ...s, [k]: v }));
  const save = async (e) => {
    e.preventDefault();
    try {
      if (editId) await api.put(`/admin/categories/${editId}`, f);
      else await api.post("/admin/categories", f);
      toast.success("Category saved");
      setF(EMPTY);
      setEditId(null);
      reload();
    } catch (err) {
      toast.error(formatError(err));
    }
  };
  const remove = async (c) => {
    if (!window.confirm(`Delete category "${c.name}"?`)) return;
    try {
      await api.delete(`/admin/categories/${c.id}`);
      toast.success("Category deleted");
      reload();
    } catch (err) {
      toast.error(formatError(err));
    }
  };
  return (
    <div data-testid="admin-categories">
      <AdminTitle title="Categories">Organise articles within the Direction and Understanding hubs.</AdminTitle>
      <form onSubmit={save} className="card-soft !bg-white p-5 grid gap-4 md:grid-cols-[1fr_1fr_1fr_2fr_auto] items-end mb-6" data-testid="category-form">
        <AInput id="cat-name" label="Name" value={f.name} onChange={set("name")} required />
        <AInput id="cat-slug" label="Slug" value={f.slug} onChange={set("slug")} required pattern="[a-z0-9-]+" />
        <ASelect id="cat-hub" label="Hub" value={f.hub} onChange={set("hub")} options={[["direction", "Direction"], ["understanding", "Understanding"]]} />
        <AInput id="cat-description" label="Description" value={f.description} onChange={set("description")} />
        <button type="submit" className="btn-primary" data-testid="category-save-button">{editId ? "Update" : "Add"}</button>
      </form>
      <Table head={["Name", "Hub", "Slug", "Actions"]} testId="admin-categories-table">
        {(data || []).map((c) => (
          <tr key={c.id}>
            <td className="px-4 py-3 font-medium">{c.name}</td>
            <td className="px-4 py-3 capitalize">{c.hub}</td>
            <td className="px-4 py-3">{c.slug}</td>
            <td className="px-4 py-3 space-x-3 whitespace-nowrap">
              <button className="btn-ghost" onClick={() => { setEditId(c.id); setF({ slug: c.slug, hub: c.hub, name: c.name, description: c.description || "" }); }} data-testid={`edit-category-${c.hub}-${c.slug}`}>Edit</button>
              {user.role === "admin" && <button className="btn-ghost !text-clay-dark" onClick={() => remove(c)} data-testid={`delete-category-${c.hub}-${c.slug}`}>Delete</button>}
            </td>
          </tr>
        ))}
      </Table>
    </div>
  );
}
